import React from "react";
import { Calendar } from "primereact/calendar";

export const Calendars = ({ onChange, value, yearRange = "2016:2026", maxDate = null, minDate = null, showTime = false, showSeconds = false, dateFormat = "dd/mm/yy", disabled = false,inputClassName ,ClassName,placeholder="" }) => {
    var TH = {
       // firstDayOfWeek: 1,
        dayNames: ["อาทิตย์", "จันทร์", "อังคาร", "พุทธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
        dayNamesShort: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        dayNamesMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        monthNames: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
        monthNamesShort: ["ม.ค.", "ก.พ.", "มี.ค", "เม.ย", "พ.ค", "มิ.ย", "ก.ค.", "ส.ค", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
        today: "วันนี้",
        clear: "ล้าง",
        dateFormat: "dd/mm/yyyy",
        weekHeader: "Sm",
    };
    return (
        <Calendar
            inputClassName={inputClassName}
            ClassName ={ClassName}
            onChange={onChange}
            value={value || null}
            yearRange={yearRange}
            dateFormat={dateFormat}
            showIcon={true}
            showTime={showTime}
            locale={TH}
            showButtonBar
            monthNavigator
            yearNavigator
            appendTo={document.body}
            maxDate={maxDate}
            minDate={minDate}
            showSeconds={showSeconds}
            disabled={disabled}
            placeholder={placeholder}
            stepMinute={5}
    
        />
    );
};
